/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {QOptionGroup,QSeparator,ClosePopup,Ripple,Dialog,Notify,AppVisibility} from 'quasar'



export default { config: {"screen":{"bodyClasses":true},"capacitor":{"iosStatusBarPadding":false}},components: {QOptionGroup,QSeparator},directives: {ClosePopup,Ripple},plugins: {Dialog,Notify,AppVisibility} }

